import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const CreateRegion = (props) => {
  const httpClient = useHttpClient(true);
  const [countries, setCountries] = useState([]);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [Open, setOpen] = useState(false);
  const [CreateModal, setCreateModal] = useState(false);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const regionData = { name: data['region_name'], country: JSON.parse(data['country']) };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/region`, regionData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.regions();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('region_name');
    setCreateModal(!CreateModal);
  };
  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient]);
  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_region')}
      </Button>
      <Modal isOpen={CreateModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_region')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="region_name"
                    id="region_name"
                    aria-invalid={errors.reion_name ? 'true' : 'false'}
                    placeholder={props.t('region_name')}
                    {...register('region_name', { required: true })}
                  />
                  <span>{errors.reion_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select name="country" id="country" className="form-control" {...register('country')}>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateRegion);
